// src/components/SearchForm.jsx
import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import api from '../api'; // Убедитесь, что путь правильный
import './loading-spinner.css'; // Убедитесь, что стили подключены и путь правильный
import {SearchContext} from '../context/SearchContext'; // Убедитесь, что путь правильный
import StarsDemo from '../utils/animateWhiteStar'; // Убедитесь, что путь правильный и компонент существует

const SearchForm = ({
                        // +++ Принимаем новый пропс для предзаполнения +++
                        initialProblem,
                        // --- Остальные пропсы из вашего исходного кода ---
                        onSearch, // Callback в HeaderSearch для передачи результатов API
                        cities,
                        cityName, // Используется для обновления контекста
                        stateName, // Используется для обновления контекста
                        selectedCityName, // Используется для API запроса
                        selectedStateName, // Используется для API запроса
                        states,
                        zipCode, // Принимается от HeaderSearch (установленный геолокацией)
                        specialization,
                        onSpecializationChange, // Callback для сброса специализации
                        languages,
                        isAllSpecializationActive, // Возможно, не используется напрямую здесь, но передается
                        freeConsultation,
                        foundationYears,
                        minimizeBanner,
                        minimizeHeader,
                    }) => {

    // --- Используем initialProblem для начального значения searchText ---
    const [searchText, setSearchText] = useState(initialProblem || '');

    // --- Состояния из вашего исходного кода ---
    // Переименовал, чтобы не было конфликта с suggestion из контекста
    const [suggestionText, setSuggestionText] = useState('');
    const inputRef = useRef(null);
    const prevRequestData = useRef({}); // Для предотвращения дублирующих запросов

    // +++ Состояние для отслеживания, сработал ли авто-запуск +++
    const [autoSearchHasRun, setAutoSearchHasRun] = useState(false);

    // --- Получение данных и методов из контекста (как в исходном коде) ---
    const {
        setSearchSource, // Устанавливается источник поиска
        setCurrentPage, // Устанавливается текущая страница
        changeSearchSended, // Флаг отправки поиска
        setSpecialization, // Обновление специализации в контексте
        setProblem, // Обновление проблемы в контексте
        setCities, // Обновление городов в контексте
        setStates, // Обновление штатов в контексте
        setZipCode, // Обновление ZIP в контексте (тем же значением, что пришло в пропсах)
        setLanguage, // Обновление языков в контексте
        setFreeConsultation, // Обновление флага конс. в контексте
        setFoundationYears, // Обновление лет осн. в контексте
        setLoading, // Управление состоянием загрузки
        loading, // Состояние загрузки
        setCityName, // Обновление имени города в контексте
        setStateName // Обновление имени штата в контексте
        // Добавьте другие методы/состояния контекста, если они используются
    } = useContext(SearchContext);

    // --- Константа из исходного кода ---
    const ALL_SPECIALIZATION = {id: null, name: 'All'};

    // --- Оборачиваем handleSearch в useCallback для стабильности ---
    // Эта функция содержит ВАШУ ИСХОДНУЮ ЛОГИКУ ВЫЗОВА API
    const handleSearch = useCallback(async (page = 1) => {
        const normalizeLanguages = (selectedLanguages) => {
            if (!Array.isArray(selectedLanguages)) {
                return [];
            }
            return selectedLanguages
                .map((lang) => {
                    if (!lang) return null;
                    if (typeof lang === 'string') return lang;
                    if (typeof lang.name === 'string') return lang.name;
                    if (lang.name && typeof lang.name.name === 'string') return lang.name.name;
                    if (typeof lang.code === 'string') return lang.code;
                    return null;
                })
                .filter(Boolean);
        };

        const normalizeFoundationYears = (selectedRanges) => {
            if (!Array.isArray(selectedRanges) || selectedRanges.length === 0) {
                return [];
            }

            const currentYear = new Date().getFullYear();
            const yearsSet = new Set();

            selectedRanges.forEach((item) => {
                if (!item) {
                    return;
                }

                let range = null;

                if (Array.isArray(item)) {
                    range = item;
                } else if (Array.isArray(item.range)) {
                    range = item.range;
                } else if (item.year && Array.isArray(item.year.range)) {
                    range = item.year.range;
                }

                if (!range || range.length !== 2) {
                    return;
                }

                let [start, end] = range;

                const startAge = Number.isFinite(start) ? start : 0;
                let endAge;
                if (!Number.isFinite(end) || end === Number.POSITIVE_INFINITY || end >= Number.MAX_VALUE) {
                    // Treat open-ended "20+ years" buckets as anything from 1900 onwards.
                    endAge = currentYear - 1900;
                } else {
                    endAge = end;
                }

                const rangeStartYear = Math.max(1900, currentYear - endAge);
                const rangeEndYear = Math.max(1900, currentYear - startAge);

                for (let year = rangeStartYear; year <= rangeEndYear; year += 1) {
                    yearsSet.add(year);
                }
            });

            return Array.from(yearsSet).sort((a, b) => a - b);
        };

        const extractIds = (items, idKeyCandidates) => {
            if (!Array.isArray(items)) {
                return [];
            }
            return items
                .map((item) => {
                    if (item == null) {
                        return null;
                    }
                    if (typeof item === 'number') {
                        return item;
                    }
                    if (typeof item === 'string' && item.trim().length > 0) {
                        const parsed = Number(item);
                        return Number.isNaN(parsed) ? null : parsed;
                    }
                    if (typeof item === 'object') {
                        for (const key of idKeyCandidates) {
                            const value = item[key];
                            if (typeof value === 'number') {
                                return value;
                            }
                            if (typeof value === 'string') {
                                const parsed = Number(value);
                                if (!Number.isNaN(parsed)) {
                                    return parsed;
                                }
                            }
                        }
                    }
                    return null;
                })
                .filter((value) => value !== null && value !== undefined);
        };

        const languageNames = normalizeLanguages(languages);
        const normalizedFoundationYears = normalizeFoundationYears(foundationYears);
        const cityIds = extractIds(cities, ['city_id', 'id']);
        const stateIds = extractIds(states, ['state_id', 'id']);

        // Формируем данные запроса на основе текущего состояния и пропсов
        const requestData = {
            problem: searchText, // Текущий текст в поле ввода
            city_name: selectedCityName || null, // Имя города из пропсов
            state_name: selectedStateName || null, // Имя штата из пропсов
            zip_code: zipCode, // ZIP из пропсов (от геолокации в HeaderSearch)
            specialization, // Текущая выбранная специализация из пропсов
            language: languageNames, // Отфильтрованные по названиям языки
            free_consultation: freeConsultation, // Флаг беспл. конс. из пропсов
            foundation_years: normalizedFoundationYears, // Нормализованные годы основания
            cities: cityIds,
            states: stateIds,
            page
        };

        console.log("SearchForm: Попытка вызова API:", requestData);

        // Проверка на дубликат запроса
        if (JSON.stringify(prevRequestData.current) === JSON.stringify(requestData)) {
             console.log("SearchForm: Запрос дублируется, отмена.");
             return;
        }
        prevRequestData.current = requestData; // Сохраняем текущий запрос

        // Установка состояний перед запросом
        if (setSearchSource) setSearchSource('form'); else console.warn("setSearchSource is not available in context");
        if (minimizeBanner) minimizeBanner();
        if (minimizeHeader) minimizeHeader();
        if (setLoading) setLoading(true); else console.warn("setLoading is not available in context");
        setSuggestionText(''); // Очищаем предыдущие подсказки/ошибки

        try {
            // Сигнализируем об отправке поиска
            if (changeSearchSended) changeSearchSended(); else console.warn("changeSearchSended is not available in context");

            // --- ВАШ ИСХОДНЫЙ ВЫЗОВ API ---
             if (api && typeof api.post === 'function') {
                 const response = await api.post('/get-filtered-specialization/', requestData);
                 const apiResults = response.data;
                 // Используем suggestion от API или дефолтное сообщение
                 const aiSuggestion = apiResults.suggestion || "AI suggests contacting a specific company...";

                 // Вызываем onSearch (переданный из HeaderSearch) с результатами API
                 if (onSearch) {
                     onSearch(
                         { results: apiResults.results, count: apiResults.count, page, suggestion: aiSuggestion },
                         specialization // Передаем специализацию, с которой был сделан запрос
                     );
                 } else {
                      console.warn("onSearch prop is not provided to SearchForm");
                 }

                 // Обновляем глобальное состояние в контексте (как и было)
                 if(setCurrentPage) setCurrentPage(page);
                 if(setSpecialization) setSpecialization(specialization);
                 if(setProblem) setProblem(searchText);
                 if(setCities) setCities(cities); // Используем cities из пропсов
                 if(setStates) setStates(states); // Используем states из пропсов
                 if(setZipCode) setZipCode(zipCode); // Используем zipCode из пропсов
                 if(setLanguage) setLanguage(languageNames); // Сохраняем уже нормализованные языки
                 if(setFreeConsultation) setFreeConsultation(freeConsultation);
                 if(setFoundationYears) setFoundationYears(normalizedFoundationYears);
                 if(setCityName) setCityName(selectedCityName || ''); // Используем имена из пропсов
                 if(setStateName) setStateName(selectedStateName || '');

             } else {
                  console.error("api.post is not a function or api is undefined in SearchForm");
                   // Можно установить сообщение об ошибке, если API недоступен
                  setSuggestionText("Search service is currently unavailable.");
                   if (onSearch) { onSearch({ results: [], count: 0, page: 1, suggestion: "Search service unavailable." }, specialization); }
             }
             // --- КОНЕЦ ВЫЗОВА API ---

        } catch (error) {
            console.error('SearchForm: Ошибка при вызове API:', error);
            // Формируем сообщение об ошибке/предложение
            const aiSuggestion = (error.response?.data?.suggestion) || "An error occurred during the search.";
            setSuggestionText(aiSuggestion); // Устанавливаем локальное сообщение

            // Вызываем onSearch с пустыми результатами и сообщением об ошибке
            if (onSearch) {
                onSearch({ results: [], count: 0, page: 1, suggestion: aiSuggestion }, specialization);
            }
        } finally {
            // Завершаем загрузку в любом случае
            if (setLoading) setLoading(false);
        }
    // --- Зависимости для useCallback ---
    // Включаем все переменные/функции из внешнего скоупа, которые используются внутри handleSearch
    }, [
        searchText, selectedCityName, selectedStateName, zipCode, specialization, languages,
        freeConsultation, foundationYears, cities, states, // Добавляем cities, states
        onSearch, setSearchSource, minimizeBanner, minimizeHeader, setLoading, changeSearchSended,
        setCurrentPage, setSpecialization, setProblem, setCities, setStates, setZipCode,
        setLanguage, setFreeConsultation, setFoundationYears, setCityName, setStateName
    ]);

    // --- useEffect для установки initialProblem (добавлено) ---
    // Устанавливает searchText при монтировании или изменении initialProblem
    useEffect(() => {
        // Обновляем, только если initialProblem не пустой и отличается от текущего searchText
        // Это предотвращает перезапись, если пользователь уже начал печатать
        if (initialProblem && initialProblem !== searchText) {
            // Дополнительная проверка: если поле пустое, точно обновляем.
            // Если не пустое - обновляем только если оно равно старому initialProblem (сложно проверить без prevProps)
            // Простой вариант: обновляем, если отличается.
            console.log("SearchForm: Установка searchText из initialProblem:", initialProblem);
            setSearchText(initialProblem);
        }
    }, [initialProblem]); // Зависимость от initialProblem


    // --- useEffect для обновления поля при выборе специализации (исходный, немного адаптирован) ---
    useEffect(() => {
         const isSpecializationSelected = specialization && specialization.name !== 'All';
         const currentTextIsFromURL = initialProblem && searchText === initialProblem;
         const canUpdateFromSpecialization = searchText === '' || !currentTextIsFromURL; // Обновляем, если поле пустое или текст не из URL

         if (isSpecializationSelected && canUpdateFromSpecialization && searchText !== specialization.name) {
             setSearchText(specialization.name);
         }
         // Логику очистки при выборе 'All' оставляем как в оригинале (не очищает, если не пусто)

    }, [specialization, initialProblem, searchText]); // Добавлены зависимости


    // +++ useEffect для автоматического запуска поиска (добавлено) +++
    useEffect(() => {
        // Запускаем, если: есть initialProblem, searchText ему равен, авто-запуск не было, не грузится
        if (initialProblem && searchText === initialProblem && !autoSearchHasRun && !loading) {
            console.log("SearchForm: Автоматический запуск поиска для:", initialProblem);
            handleSearch(1); // Вызываем API-запрос
            setAutoSearchHasRun(true); // Ставим флаг
        }
    }, [initialProblem, searchText, autoSearchHasRun, loading, handleSearch]); // Зависимости


    // --- useEffect для обработки нажатия Enter (исходный) ---
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                event.preventDefault(); // Предотвращаем стандартный сабмит формы
                if (searchText.trim().length === 0) {
                    return; // Не ищем по пустому запросу
                }
                // setAutoSearchHasRun(false); // Опционально: разрешить повторный авто-поиск после ручного
                handleSearch(1); // Вызываем наш поиск
            }
        };
        const inputElement = inputRef.current;
        if (inputElement) {
            inputElement.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            if (inputElement) {
                inputElement.removeEventListener('keydown', handleKeyDown);
            }
        };
    }, [searchText, handleSearch]); // Зависимость от searchText и handleSearch


    // --- Обработчик изменения поля ввода (исходный + сброс флага) ---
    const handleChange = (e) => {
        const newValue = e.target.value;
        setSearchText(newValue);
        setAutoSearchHasRun(true); // Любой ввод отменяет будущий авто-запуск

        // Сброс специализации при ручном вводе (исходная логика)
        if (specialization && specialization.name !== 'All' && newValue !== specialization.name) {
             if (onSpecializationChange) {
                 onSpecializationChange(ALL_SPECIALIZATION);
             } else { console.warn("onSpecializationChange is not provided to SearchForm"); }
        }
        // Класс 'fill' (исходная логика)
        if (newValue.length > 0) {
            e.target.classList.add('fill');
        } else {
            e.target.classList.remove('fill');
        }
    };

    // --- Обработчик потери фокуса (исходный) ---
    const handleBlur = (e) => {
        if (e.target.value.length > 0) {
            e.target.classList.add('fill');
        } else {
            e.target.classList.remove('fill');
        }
    };

    // --- Обработчик очистки поля (исходный + сброс флага) ---
    const handleClear = () => {
        setSearchText('');
        setAutoSearchHasRun(true); // Очистка отменяет будущий авто-запуск
        // Сброс специализации при очистке (исходная логика)
        if (specialization && specialization.name !== 'All' && onSpecializationChange) {
            onSpecializationChange(ALL_SPECIALIZATION);
        }
        if (inputRef.current) {
            inputRef.current.classList.remove('fill');
        }
    };

    // --- Обработчик фокуса (исходный) ---
    const handleFocus = () => {
        if (minimizeBanner) minimizeBanner();
        if (minimizeHeader) minimizeHeader();
    };


    // --- JSX рендеринг (исходный + атрибуты disabled/readOnly + onSubmit на форме) ---
    return (
        // Добавляем onSubmit на форму для лучшей обработки Enter
        <form className="search__input" onSubmit={(e) => {e.preventDefault(); handleSearch(1);}}>
            <label className="label">
                <input
                    className={`input js--check-fill ${searchText.length > 0 ? 'fill' : ''}`}
                    type="text"
                    value={searchText} // Значение из состояния
                    ref={inputRef}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    readOnly={loading} // Блокируем ввод во время загрузки
                    placeholder="" // Плейсхолдер управляется через CSS/div ниже
                />
                <div className="placeholder">
                     {/* Убедитесь, что пути к иконкам верны */}
                    <img src="assets/icon--zoom-DblF_61P.svg" alt="Search icon"/>
                    <span>Select a specialization or write your problem</span>
                </div>
                <div className="buttons">
                    {/* Кнопка очистки */}
                    <button
                        className="clear js--search-clear"
                        type="button" // Важно: не submit
                        onClick={handleClear}
                        style={{ visibility: searchText.length > 0 ? 'visible' : 'hidden' }}
                        disabled={loading} // Блокируем во время загрузки
                    >
                        <img src="assets/icon--cross-C4Q-00Ld.svg" alt="Clear button"/>
                    </button>
                    {/* Кнопка поиска/Enter */}
                    <button
                        className="button-black"
                        type="submit" // Теперь это submit для формы
                        disabled={loading || searchText.trim().length === 0} // Блокируем при загрузке или пустом вводе
                    >
                        {loading ? (
                            <div className="pressed">
                                {typeof StarsDemo === 'function' && <StarsDemo/>}
                                {/* Здесь можно добавить текст "Searching..." или спиннер */}
                            </div>
                        ) : (
                            <div className="pulled">
                                <span>Enter →</span>
                            </div>
                        )}
                    </button>
                </div>
            </label>
             {/* Отображение локального suggestionText (например, для ошибок) */}
             {suggestionText && <div className="search-suggestion-text">{suggestionText}</div>} {/* Пример класса */}
        </form>
    );
};

export default SearchForm;
